import { render, staticRenderFns } from "./PhotoInstructionsModal.vue?vue&type=template&id=c922fb4a"
import script from "./PhotoInstructionsModal.vue?vue&type=script&lang=js"
export * from "./PhotoInstructionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports